var _linearGradient, _path, _linearGradient2, _path2, _path3, _radialGradient, _path4, _radialGradient2, _path5, _radialGradient3, _path6, _radialGradient4, _path7, _radialGradient5, _path8, _radialGradient6, _path9, _linearGradient3, _path10, _g, _g2, _g3, _g4, _g5, _g6, _path11, _path12, _path13, _g7, _g8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTutor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--noto",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab20874",
    gradientUnits: "userSpaceOnUse",
    x1: 63.999,
    y1: 116.605,
    x2: 63.999,
    y2: 39.511,
    gradientTransform: "matrix(1 0 0 -1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#26a69a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00796b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#IconifyId17ecdb2904d178eab20874)",
    d: "M6.36 10.9h115.29v77.52H6.36z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab20875",
    gradientUnits: "userSpaceOnUse",
    x1: 63.999,
    y1: 119.455,
    x2: 63.999,
    y2: 37.224,
    gradientTransform: "matrix(1 0 0 -1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8d6e63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#795548"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.29 13.26v72.81H8.71V13.26h110.58M124 8.55H4v82.23h120V8.55z",
    fill: "url(#IconifyId17ecdb2904d178eab20875)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9 79.85c-1.25-2.27.34-4.58 3.06-7.44c4.31-4.54 9-15.07 4.64-25.76c.03-.06-.86-1.86-.83-1.92l-1.79-.09c-.57-.08-20.26-.12-39.97-.12s-39.4.04-39.97.12c0 0-2.65 1.95-2.63 2.01c-4.35 10.69.33 21.21 4.64 25.76c2.71 2.86 4.3 5.17 3.06 7.44c-1.21 2.21-4.81 2.53-4.81 2.53s.83 2.26 2.83 3.48c1.85 1.13 4.13 1.39 5.7 1.43c0 0 6.15 8.51 22.23 8.51h17.9c16.08 0 22.23-8.51 22.23-8.51c1.57-.04 3.85-.3 5.7-1.43c2-1.22 2.83-3.48 2.83-3.48s-3.61-.32-4.82-2.53z",
    fill: "#543930"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab20876",
    cx: 99.638,
    cy: 45.85,
    r: 23.419,
    gradientTransform: "matrix(1 0 0 .4912 -21.055 59.629)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#6d4c41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.99 95.79v-9.44l28.57-2.26l2.6 3.2s-6.15 8.51-22.23 8.51l-8.94-.01z",
    fill: "url(#IconifyId17ecdb2904d178eab20876)"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab20877",
    cx: 76.573,
    cy: 49.332,
    r: 6.921,
    gradientTransform: "matrix(-.9057 .4238 -.3144 -.6719 186.513 79.36)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#6d4c41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41",
    stopOpacity: 0
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1 83.16c-4.28-6.5 5.21-8.93 5.21-8.93l.01.01c-1.65 2.05-2.4 3.84-1.43 5.61c1.21 2.21 4.81 2.53 4.81 2.53s-4.91 4.36-8.6.78z",
    fill: "url(#IconifyId17ecdb2904d178eab20877)"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab20878",
    cx: 94.509,
    cy: 68.91,
    r: 30.399,
    gradientTransform: "matrix(-.0746 -.9972 .8311 -.0622 33.494 157.622)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#6d4c41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.62 46.65c4.25 10.35-.22 21.01-4.41 25.51c-.57.62-3.01 3.01-3.57 4.92c0 0-9.54-13.31-12.39-21.13c-.57-1.58-1.1-3.2-1.17-4.88c-.05-1.26.14-2.76.87-3.83c.89-1.31 20.16-1.7 20.16-1.7c0 .01.51 1.11.51 1.11z",
    fill: "url(#IconifyId17ecdb2904d178eab20878)"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab20879",
    cx: 44.31,
    cy: 68.91,
    r: 30.399,
    gradientTransform: "matrix(.0746 -.9972 -.8311 -.0622 98.274 107.563)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#6d4c41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4 46.65c-4.24 10.35.23 21.01 4.41 25.5c.58.62 3.01 3.01 3.57 4.92c0 0 9.54-13.31 12.39-21.13c.58-1.58 1.1-3.2 1.17-4.88c.05-1.26-.14-2.76-.87-3.83c-.89-1.31-1.93-.96-3.44-.96c-2.88 0-15.49-.74-16.47-.74c.01.02-.76 1.12-.76 1.12z",
    fill: "url(#IconifyId17ecdb2904d178eab20879)"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab20880",
    cx: 49.439,
    cy: 45.85,
    r: 23.419,
    gradientTransform: "matrix(-1 0 0 .4912 98.878 59.629)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#6d4c41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.03 95.79v-9.44l-28.57-2.26l-2.6 3.2s6.15 8.51 22.23 8.51l8.94-.01z",
    fill: "url(#IconifyId17ecdb2904d178eab20880)"
  })), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab20881",
    cx: 26.374,
    cy: 49.332,
    r: 6.921,
    gradientTransform: "matrix(.9057 .4238 .3144 -.6719 -13.024 100.635)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#6d4c41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41",
    stopOpacity: 0
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.92 83.16c4.28-6.5-5.21-8.93-5.21-8.93l-.01.01c1.65 2.05 2.4 3.84 1.43 5.61c-1.21 2.21-4.81 2.53-4.81 2.53s4.91 4.36 8.6.78z",
    fill: "url(#IconifyId17ecdb2904d178eab20881)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab20882",
    gradientUnits: "userSpaceOnUse",
    x1: 64,
    y1: 25.908,
    x2: 64,
    y2: 10.938,
    gradientTransform: "matrix(1 0 0 -1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1f5fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81d4fa"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M114.5 120.75c0-15.47-25.34-23.56-50.36-23.56H64c-25.14.03-50.5 7.32-50.5 23.56V124h101v-3.25z",
    fill: "url(#IconifyId17ecdb2904d178eab20882)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#e59600",
    d: "M64 92.33h-9.08v9.98l9.06 2.38l9.1-2.38v-9.98z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab20883",
    gradientUnits: "userSpaceOnUse",
    x1: 29.113,
    y1: 29.156,
    x2: 29.113,
    y2: 4.97,
    gradientTransform: "matrix(1 0 0 -1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341,
    stopColor: "#ff9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#ff7100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6f00"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12 120.75V124h32.89l1.33-27.04C27.52 99.72 12 107.15 12 120.75z",
    fill: "url(#IconifyId17ecdb2904d178eab20883)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab20884",
    gradientUnits: "userSpaceOnUse",
    x1: 98.888,
    y1: 29.435,
    x2: 98.888,
    y2: 4.807,
    gradientTransform: "matrix(1 0 0 -1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341,
    stopColor: "#ff9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#ff7100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6f00"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.78 96.96L83.1 124H116v-3.25c0-13.6-15.52-21.03-34.22-23.79z",
    fill: "url(#IconifyId17ecdb2904d178eab20884)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#66c0e8",
    d: "M54.03 92.12l9.99 12.82l-16.24 6.64l-2.41-14.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66c0e8",
    d: "M73.97 92.12l-9.99 12.82l16.24 6.64l2.41-14.54z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48.88 95s-1.14 2.72-1.94 6c-1.59 6.52-1.69 15.8-1.69 15.8s-6.89-2.34-9.04-8.05c-2.54-6.75 1.75-10.46 1.75-10.46s.9-.38 4.68-2.46s6.24-.83 6.24-.83z",
    fill: "#af5214"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M79.12 95s1.14 2.72 1.94 6c1.59 6.52 1.69 15.8 1.69 15.8s6.89-2.34 9.04-8.05c2.54-6.75-1.75-10.46-1.75-10.46s-.9-.38-4.68-2.46s-6.24-.83-6.24-.83z",
    fill: "#af5214"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M91.12 50.43H36.47c-5.89 0-10.71 5.14-10.71 11.41s4.82 11.41 10.71 11.41H91.12c5.89 0 10.71-5.14 10.71-11.41s-4.82-11.41-10.71-11.41z",
    fill: "#e59600"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.79 11.07c-17.4 0-33.52 18.61-33.52 45.4c0 26.64 16.61 39.81 33.52 39.81S97.31 83.1 97.31 56.46c0-26.78-16.11-45.39-33.52-45.39z",
    fill: "#ffca28"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#404040"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.98,
    cy: 58.81,
    rx: 4.93,
    ry: 5.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.13,
    cy: 58.81,
    rx: 4.93,
    ry: 5.1
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#6d4c41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.37 49.82c-.93-1.23-3.07-3.01-7.23-3.01s-6.31 1.79-7.23 3.01c-.41.54-.31 1.17-.02 1.55c.26.35 1.04.68 1.9.39s2.54-1.16 5.35-1.18c2.81.02 4.49.89 5.35 1.18c.86.29 1.64-.03 1.9-.39c.28-.38.39-1.01-.02-1.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.36 49.82c-.93-1.23-3.07-3.01-7.23-3.01s-6.31 1.79-7.23 3.01c-.41.54-.31 1.17-.02 1.55c.26.35 1.04.68 1.9.39s2.54-1.16 5.35-1.18c2.81.02 4.49.89 5.35 1.18c.86.29 1.64-.03 1.9-.39c.29-.38.39-1.01-.02-1.55z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M67.65 68.06c-.11-.04-.21-.07-.32-.08h-7.08c-.11.01-.22.04-.32.08c-.64.26-.99.92-.69 1.63c.3.71 1.71 2.69 4.55 2.69s4.25-1.99 4.55-2.69c.31-.71-.05-1.37-.69-1.63z",
    fill: "#e59600"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.32 76.14c-3.18 1.89-13.63 1.89-16.81 0c-1.83-1.09-3.7.58-2.94 2.24c.75 1.63 6.44 5.42 11.37 5.42s10.55-3.79 11.3-5.42c.76-1.66-1.09-3.33-2.92-2.24z",
    fill: "#795548"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M93.83 52.93c-.07-1.19-.12-1.31-1.69-1.81c-1.23-.39-7.95-.94-13.01-.66c-.36.02-.71.04-1.04.07c-4.59.39-10.1 2.24-14.24 2.34c-1.76.04-9.01-1.86-14.14-2.26c-.33-.02-.66-.05-1-.06c-5.07-.26-11.82.33-13.05.73c-1.57.51-1.62.63-1.68 1.82c-.07 1.19.13 2.2 1.06 2.51c1.27.42 1.28 2 2.13 6.54c.77 4.14 2.62 7.41 10.57 7.98c.34.02.66.04.98.04c7.03.1 9.45-4.53 10.25-6.07c1.49-2.86 1.02-6.8 4.96-6.81c3.93-.01 3.56 3.86 5.07 6.71c.81 1.53 3.17 6.18 10.14 6.08c.34 0 .69-.02 1.05-.05c7.94-.62 9.78-3.9 10.52-8.04c.82-4.55.83-6.14 2.09-6.56c.91-.3 1.11-1.31 1.03-2.5zM53.28 68.17c-1.22.57-2.85.86-4.57.86c-3.59-.01-7.57-1.27-9.01-3.81c-2.04-3.62-2.57-10.94.03-12.47c1.14-.67 4.99-1.13 8.97-.96c4.13.18 8.4 1.04 9.94 3.06c2.55 3.33-1.5 11.5-5.36 13.32zm34.9-3.1c-1.43 2.56-5.44 3.85-9.05 3.86c-1.7.01-3.31-.27-4.51-.83c-3.87-1.8-7.97-9.94-5.45-13.29c1.53-2.04 5.82-2.92 9.96-3.12c3.97-.19 7.81.25 8.94.91c2.61 1.52 2.13 8.84.11 12.47z",
    fill: "#212121",
    stroke: "#212121",
    strokeWidth: 0.55,
    strokeMiterlimit: 10
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab20885",
    gradientUnits: "userSpaceOnUse",
    x1: 79.569,
    y1: 22.713,
    x2: 76.946,
    y2: 11.668,
    gradientTransform: "matrix(1 0 0 -1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#212121",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101.67 121.61l.57-2.2l.01-.05l1.93-7.6l-6.9-1.98l-34.92-10.03c-.05-.01-.09-.01-.13-.03a6.177 6.177 0 0 0-7.51 4.27L48.97 124h52.02l.68-2.39z",
    opacity: 0.67,
    fill: "url(#IconifyId17ecdb2904d178eab20885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.75 111.88c.29-1.01-.29-2.06-1.3-2.34l-38.69-11.1a6.19 6.19 0 0 0-7.65 4.24L52 124h50.28l3.47-12.12z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab20886",
    gradientUnits: "userSpaceOnUse",
    x1: 81.84,
    y1: 17.098,
    x2: 79.869,
    y2: 10.486,
    gradientTransform: "matrix(1 0 0 -1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef5350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e53935"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.08 120.31c.35-1.22-.38-2.5-1.62-2.85l-41.52-11.9c-4.53-1.3-5.32 2.35-6.59 6.78L52 124h52.02l1.06-3.69z",
    fill: "url(#IconifyId17ecdb2904d178eab20886)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab20887",
    gradientUnits: "userSpaceOnUse",
    x1: 58.405,
    y1: 19.113,
    x2: 60.268,
    y2: 24.969,
    gradientTransform: "matrix(1 0 0 -1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424242"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.26 98.24a6.172 6.172 0 0 0-5.14 4.42L52 124h3.87l7.39-25.76z",
    fill: "url(#IconifyId17ecdb2904d178eab20887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.33 101.57c.18 0 .38.02.59.07l37.25 10.7l-.31 1.08c-11.79-3.29-34.29-9.62-38.94-11.16c.24-.33.71-.69 1.41-.69m0-3.33c-4.52 0-6.78 5.57-3.12 6.94c4.03 1.5 42.93 12.32 42.93 12.32l1.58-5.52c.31-1.06-.19-2.14-1.11-2.4L65.77 98.42c-.5-.12-.98-.18-1.44-.18z",
    fill: "#424242",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab20888",
    gradientUnits: "userSpaceOnUse",
    x1: -117.44,
    y1: -972.312,
    x2: -73.995,
    y2: -972.312,
    gradientTransform: "matrix(.9612 .2758 -.3192 1.1123 -136.555 1216.41)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.987,
    stopColor: "#f8f8f7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.37 112.12l-39.8-11.42c-1.08-.31-2.26.46-2.62 1.71l-.06.22c-.36 1.25.23 2.53 1.31 2.84l39.8 11.42s-.34-.83.07-2.3c.41-1.48 1.3-2.47 1.3-2.47z",
    fill: "url(#IconifyId17ecdb2904d178eab20888)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M104.07 25.11c-2.44-3.69-7.91-8.64-12.82-8.97c-.79-4.72-5.84-8.72-10.73-10.27c-13.23-4.19-21.84.51-26.46 3.03c-.96.52-7.17 3.97-11.51 1.5c-2.72-1.55-2.67-5.74-2.67-5.74s-8.52 3.25-5.61 12.3c-2.93.12-6.77 1.36-8.8 5.47c-2.42 4.9-1.56 8.99-.86 10.95c-2.52 2.14-5.69 6.69-3.52 12.6c1.64 4.45 8.17 6.5 8.17 6.5c-.46 8.01 1.03 12.94 1.82 14.93c.14.35.63.32.72-.04c.99-3.97 4.37-17.8 4.03-20.21c0 0 11.35-2.25 22.17-10.22c2.2-1.62 4.59-3 7.13-4.01c13.59-5.41 16.43 3.82 16.43 3.82s9.42-1.81 12.26 11.27c1.07 4.9 1.79 12.75 2.4 18.24c.04.39.57.47.72.11c.95-2.18 2.85-6.5 3.3-10.91c.16-1.55 4.34-3.6 6.14-10.26c2.41-8.88-.54-17.42-2.31-20.09z",
    fill: "#543930"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab20889",
    cx: 82.019,
    cy: 84.946,
    r: 35.633,
    gradientTransform: "matrix(.3076 .9515 .706 -.2282 -3.184 -15.605)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#6d4c41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100.22 55.5c.16-1.55 4.34-3.6 6.14-10.26c.19-.71.35-1.43.5-2.15c1.46-8.09-1.16-15.52-2.79-17.98c-2.26-3.41-7.1-7.89-11.69-8.81c-.4-.05-.79-.1-1.16-.12c0 0 .33 2.15-.54 3.86c-1.12 2.22-3.41 2.75-3.41 2.75c11.97 11.98 11.12 22 12.95 32.71z",
    fill: "url(#IconifyId17ecdb2904d178eab20889)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab20890",
    cx: 47.28,
    cy: 123.8,
    r: 9.343,
    gradientTransform: "matrix(.8813 .4726 .5603 -1.045 -63.752 111.228)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#6d4c41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.95 7.39c-1.1.53-2.06 1.06-2.9 1.51c-.96.52-7.17 3.97-11.51 1.5c-2.67-1.52-2.67-5.58-2.67-5.72c-1.23 1.57-4.95 12.78 5.93 13.53c4.69.32 7.58-3.77 9.3-7.23c.62-1.26 1.59-3.1 1.85-3.59z",
    fill: "url(#IconifyId17ecdb2904d178eab20890)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab20891",
    cx: 159.055,
    cy: 62.862,
    r: 28.721,
    gradientTransform: "matrix(-.9378 -.3944 -.2182 .5285 231.04 50.678)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#6d4c41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.16 5.47c7.32 1.98 10.89 5.71 12.08 10.68c.35 1.46.77 15.08-25.23-.4c-9.67-5.76-7.03-9.36-5.9-9.77c4.42-1.6 10.85-2.73 19.05-.51z",
    fill: "url(#IconifyId17ecdb2904d178eab20891)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab20892",
    cx: 43.529,
    cy: 115.276,
    r: 8.575,
    gradientTransform: "matrix(1 0 0 -1.2233 0 153.742)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#6d4c41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.84 4.68c-.01.01-.03.01-.06.03h-.01c-.93.39-8.24 3.78-5.51 12.25l7.78 1.25c-6.89-6.98-2.17-13.55-2.17-13.55s-.02.01-.03.02z",
    fill: "url(#IconifyId17ecdb2904d178eab20892)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab20893",
    cx: 42.349,
    cy: 100.139,
    r: 16.083,
    gradientTransform: "matrix(-.9657 -.2598 -.2432 .9037 107.598 -51.632)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#6d4c41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.07 17.73l-4.81-.77c-.19 0-.83.06-1.18.11c-2.71.38-5.9 1.78-7.63 5.36c-1.86 3.86-1.81 7.17-1.3 9.38c.15.74.45 1.58.45 1.58s2.38-2.26 8.05-2.41l6.42-13.25z",
    fill: "url(#IconifyId17ecdb2904d178eab20893)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab20894",
    cx: 38.533,
    cy: 84.609,
    r: 16.886,
    gradientTransform: "matrix(.9907 .1363 .1915 -1.3921 -15.841 155.923)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#6d4c41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.37 33.58c-2.37 2.1-5.56 6.79-3.21 12.61c1.77 4.39 8.09 6.29 8.09 6.29c0 .02 1.26.4 1.91.4l1.48-21.9c-3.03 0-5.94.91-7.82 2.22c.03.03-.46.35-.45.38z",
    fill: "url(#IconifyId17ecdb2904d178eab20894)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutor);
export default __webpack_public_path__ + "static/media/tutor.53fc6df21ddc00c76e5baa9771afb0e4.svg";
export { ForwardRef as ReactComponent };